import validate from 'jquery-validation';
validate;

export default class ContactForm {
    constructor() {
        this.section = document.querySelector('.component-contact-form');

        this.ready();
    }

    ready() {
        if (this.section) {
            require('./contact/validatorCpf');
            require('./contact/validatorReclamacao');
            require('./contact/contact-form');
        }
    }
}
if (document.querySelector('.component-contact-form')) {
    new ContactForm();
}
